/**
 * Created by fers on 26.09.15.
 */

import {declareEntity} from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';
import * as Permission from '../util/Permission.js';

export const ANNOUNCEMENTS_TYPE_LOGIN = 'login';
export const ANNOUNCEMENTS_TYPE_POPUP = 'popup';
export const ANNOUNCEMENTS_TYPE_ORG_DETAIL = 'org';
export const ANNOUNCEMENTS_TYPE_FLOW_DETAIL = 'flow';
export const ANNOUNCEMENTS_TYPE_TOP_LINE = 'top-line';
export const ANNOUNCEMENTS_TYPE_TOP_LINE_WARNING = 'top-warning';

export default declareEntity({
    entity: "announcements",
    graphQL: "Announcement",
    name: "Announcements",
    dynamoPrefix: 'sys',
    storageType: 'schema',
    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        announcementType: {
            name: "Announcements type",
            type: "enum",
            defaultValue: ANNOUNCEMENTS_TYPE_POPUP,
            values: {
                [ANNOUNCEMENTS_TYPE_POPUP]: {
                    name: "Popup"
                },
                [ANNOUNCEMENTS_TYPE_TOP_LINE]: {
                    name: "Top line"
                },
                [ANNOUNCEMENTS_TYPE_TOP_LINE_WARNING]: {
                    name: "Top line warning"
                },
                [ANNOUNCEMENTS_TYPE_LOGIN]: {
                    name: "Login screen"
                },
            }
        },
        title: {
            name: "Title",
            translatable: true,
            type: "string",
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            defaultValue: (data) => {
                return data['id'];
            }
        },
        body: {
            name: "Description",
            translatable: true,
            type: "html",
        },
        icon: {
            name: "Icon",
            type: "enum",
            visibility: (data) => { return data['announcementType'] !== ANNOUNCEMENTS_TYPE_LOGIN; },
            values: {
                "warning": {
                    name: "Warning"
                },
                "info-circle": {
                    name: "Info"
                },
                "calendar": {
                    name: "Calendar"
                },
                "credit-card": {
                    name: "Credit card"
                },
                "check-circle": {
                    name: "Check"
                },
                "comment": {
                    name: "Comment"
                },
                "birthday-cake": {
                    name: "Birthday cake"
                },
                "bug": {
                    name: "Bug"
                },
                "gift": {
                    name: "Gift"
                },
                "rocket": {
                    name: "Rocket"
                },
                "cog": {
                    name: "Cog"
                }
            }
        },
        backgroundImage: {
            name: "Background image",
            type: "url",
            visibility: (data) => { return data['announcementType'] === ANNOUNCEMENTS_TYPE_LOGIN; },
        },
        linkText: {
            name: "Link Text",
            translatable: true,
            type: "string",
        },
        link: {
            name: "Link",
            type: "url",
        },
        hide: {
            name: "Hide",
            type: "boolean",
            defaultValue: false,
        },
        validFrom: {
            name: "Valid From",
            type: "datetime",
            required: true,
            defaultValue: () => {
                return new Date();
            }
        },
        validTo: {
            name: "Valid To",
            required: true,
            type: "datetime",
            defaultValue: () => {
                return new Date(2099, 12, 31);
            },
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            visibility: (data) => { return data['announcementType'] !== ANNOUNCEMENTS_TYPE_LOGIN; },
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            visibility: (data) => { return data['announcementType'] !== ANNOUNCEMENTS_TYPE_LOGIN; },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        announcementReads: {
            type: 'manyToOne',
            to: types['announcementReads'],
            shouldFollow: false,
            foreignKeys: [
                {
                    from: "id",
                    to: "announcement_id"
                }
            ],
            permission: Permission.PERM_INSTANCE_SUPPORT,
        },
    }; }
});
